import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7bc2718"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container mb-10",
  style: {"margin-left":"0px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h5 text-primary" }, "Select Company", -1))
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h5 text-primary" }, "Select Error Type", -1))
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h5 text-primary" }, "Select Date Range", -1))
const _hoisted_9 = { class: "col-2 p-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn btn-success topmrng btn-hover-scale" }, "Export", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "h4 text-primary w-100" }, "Company Report")
], -1))
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = {
  id: "kt_referred_users_tab_content",
  class: "tab-content"
}
const _hoisted_14 = {
  id: "kt_customer_details_invoices_1",
  class: "py-0 tab-pane fade active show",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Multiselect, _mergeProps({
            class: "rounded mt-2",
            modelValue: _ctx.companyList.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyList.value) = $event))
          }, _ctx.companyList, {
            placeholder: "Select the Company",
            mode: "tags",
            "close-on-select": false,
            searchable: true,
            "create-option": true,
            loading: _ctx.companiesLoading
          }), null, 16, ["modelValue", "loading"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Multiselect, _mergeProps({
            class: "mt-2",
            modelValue: _ctx.errortype.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errortype.value) = $event))
          }, _ctx.errortype, { placeholder: "Select the Error Type" }), null, 16, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_el_date_picker, {
            class: "border border-primary rounded mt-2",
            modelValue: _ctx.date,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
            type: "daterange",
            "start-placeholder": "Start date",
            "end-placeholder": "End date"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn btn-primary topmrng btn-hover-scale",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fetchTableData && _ctx.fetchTableData(...args)))
          }, " Submit "),
          _hoisted_10
        ])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", {
      class: _normalizeClass(`card pt-2 ${_ctx.cardClasses}`)
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Datatable, {
              "table-header": _ctx.tableHeader,
              "table-data": _ctx.companyTableData,
              "rows-per-page": 8,
              loading: _ctx.loading,
              "enable-items-per-page-dropdown": false
            }, _createSlots({ _: 2 }, [
              _renderList(_ctx.keys, (key) => {
                return {
                  name: _ctx.slotName(key),
                  fn: _withCtx(({ row: company }) => [
                    _createTextVNode(_toDisplayString(company[key]), 1)
                  ])
                }
              })
            ]), 1032, ["table-header", "table-data", "loading"])
          ])
        ])
      ])
    ], 2)
  ], 64))
}